<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
</style>

<template>
  <div>
    <div class="echarts" id="stack-bar" ref="stack-bar"></div>
  </div>
</template>

<script>
export default {
  name: "echarts",
  props: {
    stack: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  watch: {
    stack() {
      this.createEcharts();
    }
  },
  mounted() {
    this.createEcharts();
  },
  methods: {
    createEcharts() {
      let barHeght = this.$refs["stack-bar"].clientHeight* 0.9;
      let barWidth = this.$refs["stack-bar"].clientWidth;
      let $echartsDOM = document.getElementById("stack-bar");
      let myEcharts = this.$echarts.init($echartsDOM);
      let nameList = [];
      let oneList = [];
      let twoList = [];
      let threeList = [];
      let fourList = [];
      for (let i = 0; i < this.stack.length; i++) {
        if (this.stack[i].name.length>4) {
          nameList.push(this.stack[i].name.slice(0,4)+ '\n' + this.stack[i].name.slice(4,this.stack[i].name.length));
        }else{
          nameList.push(this.stack[i].name);
        }
        if (this.stack[i].value[0].value==0) {
          this.stack[i].value[0].value = ''
        }
        if (this.stack[i].value[1].value==0) {
          this.stack[i].value[1].value = ''
        }
        if (this.stack[i].value[2].value==0) {
          this.stack[i].value[2].value = ''
        }
        if(this.stack[i].value[3].value==0){
          this.stack[i].value[3].value = ''
        }
        oneList.push(this.stack[i].value[0].value);
        twoList.push(this.stack[i].value[1].value);
        threeList.push(this.stack[i].value[2].value);
        fourList.push(this.stack[i].value[3].value);
      }
      let option = {
        grid: {
          top:"0",
          left: "0",
          right: "0",
          bottom: "3%",
          containLabel: true,
          height: barHeght,
          width:barWidth
        },
        xAxis: {
          type: "value",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            show: false
          }
        },
        yAxis: {
          type: "category",
          data: nameList,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show:false
          },
          axisLabel:{
            color:'#89939F',
            lineHeight:18
          }
        },
        series: [
          {
            type: "bar",
            barMinHeight: 10,
            stack: "总量",
            label: {
              normal: {
                show: true,
                position: "bottom"
              }
            },
            data: oneList,
            itemStyle: {
              normal: {
                barBorderRadius: [13, 0, 0, 13],
                color: function(params) {
                  var colorList = ["#4ACAA8", "#4ACAA8", "#4ACAA8"];
                  return colorList[params.dataIndex];
                },
                borderColor:'#fff',
                borderWidth: 2
              }
            }
          },
          {
            type: "bar",
            stack: "总量",
            barMinHeight: 10,
            label: {
              normal: {
                show: true,
                position: "bottom"
              }
            },
            data: twoList,
            itemStyle: {
              normal: {
                color: function(params) {
                  var colorList = ["#FF8E55", "#FF8E55", "#FF8E55"];
                  return colorList[params.dataIndex];
                },
                borderColor:'#fff',
                borderWidth: 2
              }
            }
          },
          {
            type: "bar",
            stack: "总量",
            barMinHeight: 10,
            label: {
              normal: {
                show: true,
                position: "bottom"
              }
            },
            data: threeList,
            itemStyle: {
              normal: {
                color: function(params) {
                  var colorList = ["#698EFF", "#698EFF", "#698EFF"];
                  return colorList[params.dataIndex];
                },
                borderColor:'#fff',
                borderWidth: 2
              }
            }
          },
          {
            type: "bar",
            barMinHeight: 10,
            stack: "总量",
            label: {
              normal: {
                show: true,
                position: "bottom"
              }
            },
            data: fourList,
            barWidth: 15,
            itemStyle: {
              normal: {
                barBorderRadius: [0, 13, 13, 0],
                color: function(params) {
                  var colorList = ["#FFCC5C", "#FFCC5C", "#FFCC5C"];
                  return colorList[params.dataIndex];
                },
                borderColor:'#fff',
                borderWidth: 2
              }
            }
          }
        ]
      };
      myEcharts.setOption(option);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/echarts_bar-stack/index.vue